import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "hidden lg:block w-[285px] pr-6 relative" }
const _hoisted_2 = { class: "space-y-2 sticky top-[100px]" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 3,
  class: "px-4 py-2"
}
const _hoisted_5 = {
  key: 0,
  class: "bg-background border shrink-0 md:hidden fixed rounded-full bottom-20 sm:bottom-5 right-4 p-5"
}
const _hoisted_6 = { class: "grid gap-4 text-lg font-medium pt-8" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 3,
  class: "px-4 py-2"
}

import { useRouter } from 'vue-router';
import Button from '@/components/ui/button/Button.vue';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useAuth } from '@/composables/useAuth';
import { useAxios } from '@/composables/useAxios';
import { AclEnum } from '@/enums/acl/AclEnum';
import { communities } from '@/states/communities';
import { FolderPlusIcon, GlobeIcon, Menu, Trash2 } from 'lucide-vue-next';
import { onMounted, ref } from 'vue';
import { useTenant } from '@/composables/useTenant'
import { useToast } from '@/components/ui/toast';


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedMenu',
  setup(__props) {

const { tenant } = useTenant()
const { hasRoles, organization, userAuthenticated } = useAuth()
const axios = useAxios()
const { toast } = useToast()
const router = useRouter()

const isDeleteDialogOpen = ref(false)
const communityToDelete = ref<{ id: number, courseId: number } | null>(null)
const isDeleting = ref(false)

function getCommunities() {
  axios.get('/courses/communities')
    .then((res) => {
      communities.value = res.data
    })
}

function canDeleteCommunity(community: any) {
  if (hasRoles([AclEnum.ADMIN_MEMBER_AREA])) return true;
  
  const isProducer = hasRoles([AclEnum.PRODUCER]);
  const isAdmin = hasRoles([AclEnum.ADMIN]);
  const isOwner = userAuthenticated.organizationIds?.some(id => String(id) == String(community.organizationId));
  
  if (isAdmin && tenant.value?.id === 1) return true;
  
  return (isProducer || isAdmin) && isOwner;
}

function openDeleteModal(id: number, courseId: number) {
  const community = communities.value?.find(c => c.id === id);
  if (community && !canDeleteCommunity(community)) {
    toast({
      title: 'Acesso negado',
      description: 'Você não tem permissão para excluir esta comunidade.',
      variant: 'destructive'
    })
    return;
  }
  
  communityToDelete.value = { id, courseId }
  isDeleteDialogOpen.value = true
}

function handleConfirmDelete() {
  if (communityToDelete.value) {
    const community = communities.value?.find(c => c.id === communityToDelete.value?.id);
    if (community && !canDeleteCommunity(community)) {
       toast({
        title: 'Acesso negado',
        variant: 'destructive'
      })
      isDeleteDialogOpen.value = false
      return;
    }

    isDeleting.value = true
    axios.delete(`/courses/${communityToDelete.value.courseId}/communities/${communityToDelete.value.id}`)
      .then(() => {
        toast({
          title: 'Comunidade excluída com sucesso',
          class: 'bg-green-500 text-white'
        })
        isDeleteDialogOpen.value = false
        getCommunities()
        router.push({ name: 'feed' })
      })
      .catch(() => {
        toast({
          title: 'Erro ao excluir comunidade',
          variant: 'destructive'
        })
      })
      .finally(() => {
        isDeleting.value = false
      })
  }
}

onMounted(() => {
  getCommunities()
})

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          class: "inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start",
          to: { name: 'feed' },
          "active-class": 'bg-accent'
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(GlobeIcon)), { class: "h-5 w-5 mr-2" })),
            _cache[2] || (_cache[2] = _createTextVNode(" Explorar "))
          ]),
          _: 1
        }),
        (_unref(hasRoles)([_unref(AclEnum).PRODUCER, _unref(AclEnum).ADMIN]) && _unref(tenant)?.id === 1 || _unref(hasRoles)([_unref(AclEnum).ADMIN_MEMBER_AREA]))
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              class: "inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start",
              to: { name: 'courses.communities.create' },
              "active-class": 'bg-accent'
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(FolderPlusIcon)), { class: "h-5 w-5 mr-2" })),
                _cache[3] || (_cache[3] = _createTextVNode(" Adicionar comunidade "))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(communities))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(5, (i) => {
              return _createElementVNode("a", {
                key: i,
                class: "inline-flex h-10 px-4 py-2 w-full rounded-md animate-pulse bg-accent/20"
              })
            }), 64))
          : (_unref(communities) && _unref(communities).length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(communities), (community) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: community.id,
                  class: "group flex items-center justify-between gap-1"
                }, [
                  _createVNode(_component_RouterLink, {
                    class: "truncate inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start",
                    "active-class": 'bg-accent',
                    to: { name: 'courses.communities.show', params: { courseId: community.courseId, communityId: community.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(community.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (canDeleteCommunity(community))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (openDeleteModal(community.id, community.courseId)), ["stop","prevent"]),
                        class: "p-2 text-muted-foreground hover:text-destructive transition-all",
                        title: "Excluir comunidade"
                      }, [
                        _createVNode(_unref(Trash2), { class: "h-4 w-4" })
                      ], 8, _hoisted_3))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[4] || (_cache[4] = [
                _createElementVNode("p", { class: "text-xs text-zinc-500 italic" }, "Nenhuma comunidade ainda", -1)
              ])))
      ])
    ]),
    _createVNode(_unref(Sheet), null, {
      default: _withCtx(() => [
        _createVNode(_unref(SheetTrigger), { "as-child": "" }, {
          default: _withCtx(() => [
            (!_ctx.$route.path.includes('/topic'))
              ? (_openBlock(), _createElementBlock("button", _hoisted_5, [
                  _createVNode(_unref(Menu), { class: "h-5 w-5" }),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "sr-only" }, "Toggle navigation menu", -1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(SheetContent), { side: "left" }, {
          default: _withCtx(() => [
            _createElementVNode("nav", _hoisted_6, [
              _createVNode(_component_RouterLink, {
                class: "inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start",
                to: { name: 'feed' },
                "active-class": 'bg-accent'
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(GlobeIcon)), { class: "h-5 w-5 mr-2" })),
                  _cache[6] || (_cache[6] = _createTextVNode(" Explorar "))
                ]),
                _: 1
              }),
              (_unref(hasRoles)([_unref(AclEnum).PRODUCER, _unref(AclEnum).ADMIN]) && _unref(tenant)?.id === 1 || _unref(hasRoles)([_unref(AclEnum).ADMIN_MEMBER_AREA]))
                ? (_openBlock(), _createBlock(_component_RouterLink, {
                    key: 0,
                    class: "inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start",
                    to: { name: 'courses.communities.create' },
                    "active-class": 'bg-accent'
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(FolderPlusIcon)), { class: "h-5 w-5 mr-2" })),
                      _cache[7] || (_cache[7] = _createTextVNode(" Adicionar comunidade "))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(communities))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(5, (i) => {
                    return _createElementVNode("a", {
                      key: i,
                      class: "inline-flex h-10 px-4 py-2 w-full rounded-md animate-pulse bg-accent/20"
                    })
                  }), 64))
                : (_unref(communities) && _unref(communities).length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(communities), (community) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: community.id,
                        class: "group flex items-center justify-between gap-1"
                      }, [
                        _createVNode(_component_RouterLink, {
                          class: "truncate inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start",
                          "active-class": 'bg-accent',
                          to: { name: 'courses.communities.show', params: { courseId: community.courseId, communityId: community.id } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(community.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (canDeleteCommunity(community))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _withModifiers(($event: any) => (openDeleteModal(community.id, community.courseId)), ["stop","prevent"]),
                              class: "p-2 text-muted-foreground hover:text-destructive transition-all",
                              title: "Excluir comunidade"
                            }, [
                              _createVNode(_unref(Trash2), { class: "h-4 w-4" })
                            ], 8, _hoisted_7))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[8] || (_cache[8] = [
                      _createElementVNode("p", { class: "text-xs text-zinc-500 italic" }, "Nenhuma comunidade ainda", -1)
                    ])))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Dialog), {
      open: isDeleteDialogOpen.value,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((isDeleteDialogOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogContent), { class: "sm:max-w-[425px] bg-zinc-950 border-zinc-800 text-white" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), { class: "text-xl font-bold" }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("Excluir Comunidade")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), { class: "text-zinc-400" }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode(" Você tem certeza que deseja excluir esta comunidade? Esta ação é irreversível e removerá todos os tópicos e publicações associados. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogFooter), { class: "mt-6 flex gap-2" }, {
              default: _withCtx(() => [
                _createVNode(Button, {
                  variant: "ghost",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isDeleteDialogOpen.value = false)),
                  class: "hover:bg-zinc-800"
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode(" Cancelar ")
                  ])),
                  _: 1
                }),
                _createVNode(Button, {
                  variant: "destructive",
                  onClick: handleConfirmDelete,
                  disabled: isDeleting.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(isDeleting.value ? 'Excluindo...' : 'Excluir'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})